import React, { useState } from "react";
import SidebarLogo from "./Sidebar/SidebarLogo";
import { Button, Form, Input, notification, Select, Tooltip } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import { labelComponent } from "./../util/UtilComponents";
import { countries } from "../constants/country";
import { useDispatch, useSelector } from "react-redux";
import { axiosInstance, BASE_API_CONFIG } from "../util/Api";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { fetchStart, fetchSuccess } from "../appRedux/actions";

const FormItem = Form.Item;

const LoginOtpMobileNo = () => {
  const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState("+00");
  const { Option } = Select;
  const loading = useSelector(({ common }) => common.loading);
  const history = useHistory();
  const dispatch = useDispatch();
  const onFinishFailed = (errorInfo) => {};
  const onFinish = async (values) => {
    try {
      const { mobile, country } = values;
      const selected = countries.find((item) => item.name === country);

      const fullMobile = `${selected?.dial_code}${mobile}`;
      dispatch(fetchStart());
      const response = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/auth/whatsapp/login/otp`,
        {
          mobile: fullMobile,
        }
      );
      history.push("/loginwithotp", {
        mobile: fullMobile,
      });
      console.log("OTP sent successfully", response.data);
    } catch (error) {
      console.error("OTP error", error);
      notification.error({
        message: "Error",
        description:
          "Mobile number is not registered. Please check the number.",
      });
    } finally {
      dispatch(fetchSuccess());
    }
  };
  const handleClick = () => {
    history.push("/signin");
  };

  return (
    <>
      <div
        className="gx-login-container"
        style={{ marginTop: "auto", paddingTop: 0 }}
      >
        <div style={{ width: "100%", paddingBottom: "40px" }}>
          <SidebarLogo />
        </div>
        <div className="gx-login-content">
          <div className="gx-mb-4">
            <div className="gx-login-header">OTP Verification</div>
            <p className="gx-login-description">
               Enter the registered mobile number to receive the whatsapp OTP.
            </p>
          </div>
          <Form
            form={form}
            initialValues={{ remember: true, portPairs: [] }}
            name="signup"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <FormItem
              rules={[
                { required: true, message: "Please input your Country!" },
              ]}
              name="country"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={labelComponent("Country", null)}
            >
              <Select
                showSearch
                size="large"
                name="country"
                placeholder="Country"
                onChange={(value) => {
                  const country = countries.find(
                    (country) => country?.name === value
                  );
                  setSelectedCountry(country);
                  form.resetFields(["businessType"]);
                }}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {countries?.map((country) => (
                  <Option key={country.code} value={country.name}>
                    {country.name}
                  </Option>
                ))}
              </Select>
            </FormItem>

            <FormItem
              name="mobile"
              placeholder="WhatsApp Number"
              rules={[
                {
                  required: true,
                  message:
                    "Please provide your WhatsApp-enabled mobile number!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const country = getFieldValue("country");
                    if (country === "India") {
                      if (/^[6-9]\d{9}$/.test(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "Please enter a valid 10-digit Indian WhatsApp number"
                      );
                    }
                    if (value && value.length >= 5) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      "Please enter a valid WhatsApp number"
                    );
                  },
                }),
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={labelComponent("Mobile Number")}
            >
              <Input
                maxLength={20}
                size="large"
                type="tel"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
                placeholder={"WhatsApp-registered mobile number"}
                prefix={
                  selectedCountry?.dial_code ? (
                    <div
                      style={{
                        borderRight: "1px solid #d3d3d3",
                        paddingRight: 5,
                      }}
                    >
                      {selectedCountry?.dial_code}
                    </div>
                  ) : (
                    ""
                  )
                }
                suffix={
                  <Tooltip title="Make sure this number is registered with WhatsApp">
                    <WhatsAppOutlined
                      style={{ color: "#25D366", fontSize: "20px" }}
                    />
                  </Tooltip>
                }
              />
            </FormItem>

            <FormItem
              className="gx-text-center"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                block
                loading={loading}
              >
                Send OTP
              </Button>
              <Button onClick={handleClick} type="secondary" size="large" block>
                Back
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    </>
  );
};

export default LoginOtpMobileNo;
